module.exports = __webpack_public_path__ + "img/imo.a275b768.png";